<template>
    <div class="div-home">
        <div v-if="showLoader" class="wrapper-child">
            <!--<img src="/assets/img/loader/loaderImageHome.svg" />
            <p>please wait...</p>-->
        </div>
        <div v-else class="wrapper-parent">

            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <!--<headerTop-component></headerTop-component>-->
                    <!-- responsive-header -->
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <menu-component></menu-component>
                </header>
                <!-- header -->


                <main class="main default">
                    <div class="container">
                        <div class="row">
                            <section id="main-slider" class="carousel slide carousel-fade card" data-ride="carousel">
                                <div class="carousel-inner first-banner">
                                    <div class="overlay">
                                        <h1>
                                            Welcome to <br />NorsLab!
                                        </h1>
                                    </div>
                                </div>
                            </section>
                            <nav class="main-menu">
                                <div class="">
                                    <ul data-v-1e58fd16="" class="list float-right">
                                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                                            <router-link to="/">Home</router-link>
                                        </li>
                                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                                            <router-link to="/aboutUs">About Us</router-link>
                                        </li>
                                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                                            <router-link to="/contactUs">Contact Us </router-link>
                                        </li>
                                        <li data-v-1e58fd16="" class="list-item list-item-has-children mega-menu mega-menu-col-5">
                                            <router-link to="/verification">Check</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                            <div class="company-main col-12 col-lg-12 order-1 order-lg-2">
                                <widget-product :sectionNumber="0"></widget-product>
                            </div>
                            <div class="verification-main col-12 col-lg-12 order-1 order-lg-2" style="margin-top:10px; margin-bottom:10px;">
                                <verification-Product></verification-Product>
                            </div>
                            <div class="pro-main col-12 col-lg-12 order-1 order-lg-2">
                                <our-company></our-company>
                            </div>
                            <div class="advantages-main no-padding-right no-padding-left col-12 col-lg-12 order-1 order-lg-2">
                                <!--<advantages-company></advantages-company>-->
                            </div>
                        </div>
                    </div>
                </main>
                <footer-component></footer-component>
                <!--<footer-fixnav-component></footer-fixnav-component>-->
            </div>
        </div>



    </div>
</template>

<script>
    import sliders from './sliders.vue';
    import verificationProduct from './verificationProduct.vue';
    import ourCompany from './ourCompany.vue';
    import advantagesDetail from './advantagesDetail.vue';
    import advantagesCompany from './advantagesCompany.vue';
    import widgetProduct from './widgetProduct.vue';
    import { initialSite } from "../../module/initialSite";


    export default {
        data() {
            return {
                banner: 0,
                showLoader: false,
            }
        },
        components: {
            'sliders': sliders,
            'widget-product': widgetProduct,
            'our-company': ourCompany,
            'advantages-company': advantagesCompany,
            'advantages-detail': advantagesDetail,
            'verification-Product': verificationProduct
        },
        computed: {
            banners: function () {
                return this.$store.getters.readBanners;
            }
        },
        beforeMount: function () {
            createPageTitle('Home');
            initialSite(this);
        }
    }
</script>

<style scoped>
    .verification-main {
        padding: 10px 0 10px 0;
        /*background-color: #000000;*/
        /*background-image: linear-gradient(141deg, #9fb8ad 0%,#083140 70%,#db301f 51% )*/
    }

    .tp-bging-main {
        position: relative;
    }

    .pro-main {
        background-color: #fff;
        padding: 0px !important;
    }

    .slider-main {
        background-color: #fff;
    }

    .tp-bging-main, .company-main, .slider-main {
        /*padding-left: 0;
        padding-right: 0;*/
    }

    .logo-main-navbar {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mg-top-10 {
        background: #f2f2f2;
    }

    .all-nav {
        background: #235ea3;
        border-bottom: 4px solid #235ea3;
    }

    header.main-header .logo-area a img {
        height: 50px;
        float: right;
        margin-top: 2px;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .verification-main {
            padding: 20px 0 30px 0;
        }
    }

    @media only screen and (min-width:650px) and (max-width: 850px) {
        .verification-main {
            padding: 20px 0 30px 0;
        }
    }

    @media only screen and (min-width:851px) and (max-width: 991px) {
        .verification-main {
            padding: 20px 0 30px 0;
        }
    }

    .first-banner {
        background-image: url(/assets/img/front.jpg);
        min-height: 600px;
        width: 100%;
        min-height: 550px;
        position: relative;
        background-size: cover;
        /*background-position: 50% 50%;*/
    }

        .first-banner .overlay {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.25);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 15px;
        }

        .first-banner h1 {
            max-width: 1000px;
            font-size: 50px;
            font-weight: bold;
            letter-spacing: 0;
            margin-bottom: 25px;
            text-align: center;
            font-family: opensans-heavy;
            line-height: 1.1;
        }

    .product-carousel .owl-item img, img {
        border-radius: 0px !important;
    }

    .grid-x {
        display: flex;
        flex-flow: row wrap;
    }

    .inner {
        max-width: 1200px;
        margin: 0 auto;
        padding: 5px 0;
    }

    .grid-x > .bp600-2 {
        width: 16.6666666667%;
    }

    .in-page-nav .cell {
        text-align: center;
    }
    .main-menu {
        width: 100%;
        float: left;
        background: #fff;
        margin-top: 5px;
        min-height: 50px;
        margin-bottom: 20px;
    }
    .main-menu .list {
            width: 100%;
            margin-bottom: 0;
            padding-left: 0;
            position: relative;
            list-style: none;
            text-align: center;
            background-color: #0687e6;
        }
    .main-menu .list .list-item {
                display: inline-block;
                padding: 5px;
                margin: 10px;
                border-radius: 5px;
                box-shadow: 1px 1px 1px 0px rgb(0, 0, 0);
                min-width: 130px;
                background-color: #fff;
            }
        .main-menu .list > .list-item > a,
        .main-menu .list > .list-item > span {
            color: #235ea3;
            padding: 8px 18px 8px 18px;
            border-top: 2px solid transparent;
            border-bottom: 2px solid transparent;
            position: relative;
            font-size: 16px;
            font-weight: bold;
            display: inline-block;
        }
</style>